import { User } from "../redux/user/userSlice";
import { fireGTMEvent } from "./fireGTMEvent";
import { isChromeVersionUpToDate } from "./isChromeVersionUpToDate";

type Props = {
  user?: User;
  doneRequest?: boolean;
  safariMobile?: boolean;
};

interface ExtensionResponse {
  version?: string;
  msg?: string;
}

export const sendMessageToExtension = async ({
  user,
  doneRequest = false,
  safariMobile,
}: Props): Promise<any> => {
  let data: any = {
    dev: import.meta.env.VITE_APP_EXTENSION_ENV === "dev",
    staging: import.meta.env.VITE_APP_EXTENSION_ENV === "staging",
    allowTracking: !!user?.allowTracking,
    Authorization: `Bearer ${JSON.parse(localStorage.getItem("access_token"))}`,
  };
  if (doneRequest) {
    data = { doneRequest: true, ...data };
  } else {
    data = { userRequest: true, ...data };
  }
  const runtime = safariMobile
    ? window.browser?.runtime
    : window.chrome?.runtime;

  const extenstionId = safariMobile
    ? import.meta.env.VITE_APP_SAFARI_EXTENSION_ID
    : import.meta.env.VITE_APP_EXTENSION_ID;

  console.log("runtime", runtime, safariMobile, extenstionId);

  if (!runtime)
    throw new Error(
      "Please update the extension by completely closing and reopening your browser.",
    );

  const res = await new Promise<ExtensionResponse>((r) => {
    runtime?.sendMessage(extenstionId!, data, (res: ExtensionResponse) => {
      r(res);
    });
  });

  console.log("res", res);

  if (!res)
    throw new Error(
      "Please update the extension by completely closing and reopening your browser.",
    );

  const version = res?.version;

  if (version) {
    if (!isChromeVersionUpToDate([2, 2, 20], version)) {
      throw new Error(
        "Please update the extension by completely closing and reopening your browser.",
      );
    }
    fireGTMEvent(`${safariMobile ? "safari" : "chrome"}_extension_version`, {
      version,
    });
  }

  return res;
};
